import { Link } from '@reach/router'
import React, { Component } from 'react'
import '../styles/Home.css'
import Slider from './Slider'

export class Home extends Component {
    constructor(props) {
        super(props)
        this.state = {
            join: false,
        }
        this.joinForm = this.joinForm.bind(this)
    }

    joinForm() {
        (!this.state.join ?
            this.setState({ join: true })
            :
            this.setState({ join: false }))
    }

    render() {
        return (
            <div>
                <div className="home-div">
                    <h1 className="home-header"><span className="homeheader-span">WAZITO </span> FITNESS</h1>
                    <h3 className="home-header-text">Where you achieve your fitness goals for good and healthy life</h3>
                    <Link className="join-btn" to='/contacts'>Join us</Link>
                    {/* <button onClick={this.joinForm} className="join-btn">JOIN US</button> <br /> <br />
                    {
                        this.state.join ?
                        <>
                            <div className="form-div">
                                <h3>Contact us</h3>
                                <form className="join-form">
                                    <input type="email" placeholder="Enter your Email" required/> <br />
                                    <textarea type="text" cols="30" rows="5" placeholder="Message here..." required /> <br />
                                    <input type="submit" value="submit" required/>
                                </form>
                                <p>Call/WhatsApp: +254705673263</p>
                            </div>
                        </>
                        :
                        null
                    } */}

                </div>
                <Slider />
            </div>
        )
    }
}

export default Home
